import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import Downshift from 'downshift';
import { withRouter } from 'react-router';

import {
  StyledArtwork,
  ArtworkWrapper,
} from 'components/base/EntityItem/EntityItem.style';

import CompareSearchResults from './CompareSearchResults/CompareSearchResults';

import {
  SearchLabel,
  SearchInput,
  Wrapper,
  CloseButton,
  StyledCompareListItem,
} from './CompareSearch.style';

import { ReactComponent as IconClose } from 'icons/icon-close.svg';
import { apiTypeToEntityType } from 'helpers/mapEntityTypes';
import getFollowingEntitiesData from 'helpers/getFollowingEntitiesData';

interface ICompareSearchProps {
  /** One or more ids of entities from where we want to browse */
  entityIds: string[];
  /** The current EntityType */
  entityType: string;
  /** Method to toggle the search bar */
  toggleSearchVisibility: Function;
  /** The complete list of entities that is followed and is stored in Redux */
  followingData: any;
  /** The following entities in redux */
  followingEntities: any;
  /** The sequence number in the list used to define the compare color */
  index: number;
  history: any;
  location: any;
  topic: any;
  compareMode: string;
  debouncedUpdateSearchValue?: any;
  searchInput?: any;
}

/** Search components for selecting entities in compare mode. */
class CompareSearch extends Component<ICompareSearchProps> {
  debouncedUpdateSearchValue: any;
  searchInput: any;
  constructor(props: any) {
    super(props);
    this.debouncedUpdateSearchValue = debounce(this.updateSearchValue, 500, {
      leading: true,
    });
  }

  state = {
    inputValue: '',
    searchValue: '',
    isOpen: true,
  };

  componentDidMount = (): void => {
    this.searchInput && this.searchInput.focus();
  };

  componentWillUnmount(): void {
    this.debouncedUpdateSearchValue.cancel();
  }

  onInputChange = (event: any): any => {
    const { value } = event.target;
    const nextState = {
      inputValue: value,
    };
    this.debouncedUpdateSearchValue(value);
    this.setState(nextState);
  };

  onSelect = (selection: any): any => {
    if (selection) {
      const {
        topic,
        entityType,
        toggleSearchVisibility,
        history,
        location,
        compareMode,
      } = this.props;
      const ids = [...this.props.entityIds, selection.id];
      history.push({
        ...location,
        pathname: `/compare${compareMode === 'country' ? '/country' : ''}${
          ids.length === 1 ? '/all' : ''
        }/entity/${entityType}/${ids.join(',')}/${topic.join('/')}`,
      });
      this.clearSelection();
      toggleSearchVisibility();
    }
  };

  updateSearchValue(searchValue: any): any {
    this.setState({ searchValue });
  }

  clearSelection = (): any => {
    this.setState({ inputValue: '', searchValue: '' });
  };

  render(): any {
    const {
      entityIds,
      entityType,
      toggleSearchVisibility,
      followingData,
      followingEntities,
      index,
    } = this.props;

    const label = `Search ${entityType}`;

    return (
      <Downshift
        onSelect={this.onSelect}
        itemToString={(i: any): any =>
          i === null ? '' : String(i.displayName)
        }
        onStateChange={(changes: any): any => {
          if ('isOpen' in changes) {
            this.setState({ isOpen: changes.isOpen });
          }
        }}
        isOpen={this.state.isOpen}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          getLabelProps,
          isOpen,
        }): any => {
          const entityFilter = (entity: any): any => {
            return (
              !entity ||
              (!entityIds.includes(entity.id) &&
                apiTypeToEntityType(entity.type) === entityType)
            );
          };

          /** Filter the following entities per entityType and remove it's own ID */
          const filteredFollowingEntities = followingData
            .map((item: any): any => item.entity)
            .filter(entityFilter);

          const filteredFollowingCount = (followingEntities &&
          followingEntities.length > 0
            ? followingEntities
            : []
          ).filter(entityFilter);

          return (
            <div>
              <Wrapper>
                <StyledCompareListItem loading={false} index={index}>
                  <ArtworkWrapper>
                    <StyledArtwork entityType={entityType} />
                  </ArtworkWrapper>
                  <SearchLabel {...getLabelProps()}>{label}</SearchLabel>
                  <SearchInput
                    {...(getInputProps({
                      placeholder: label,
                      onChange: this.onInputChange,
                      onFocus: () => this.setState({ isOpen: true }),
                      value: this.state.inputValue,
                    }) as any)}
                    ref={(el: any): any => (this.searchInput = el)}
                  />
                  <CloseButton onClick={toggleSearchVisibility}>
                    <IconClose />
                  </CloseButton>
                </StyledCompareListItem>

                {isOpen && (
                  <CompareSearchResults
                    filteredFollowingEntities={filteredFollowingEntities}
                    filteredFollowingCount={filteredFollowingCount}
                    entityType={entityType}
                    entityIds={entityIds}
                    getItemProps={getItemProps}
                    highlightedIndex={highlightedIndex}
                    searchValue={this.state.searchValue}
                  />
                )}
              </Wrapper>
            </div>
          );
        }}
      </Downshift>
    );
  }
}

export default withRouter(getFollowingEntitiesData(CompareSearch)) as any;
